import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { courseService } from '../services/courseService'

export const getAllCourses = createAsyncThunk('course/getAll', async (params = {}, { rejectWithValue }) => {
  try {
    const response = await courseService.getAll(params)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getAllCoursesByClass = createAsyncThunk('course/getAllByClass', async (data, { rejectWithValue }) => {
  try {
    const response = await courseService.getAllByClass(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getAllCoursesByClassSubj = createAsyncThunk('course/getAllByClassSubj', async (data, { rejectWithValue }) => {
  try {
    const response = await courseService.getAllByClassSubj(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getOneCourse = createAsyncThunk('course/getOne', async (data, { rejectWithValue }) => {
  try {
    const response = await courseService.getOne(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const createCourse = createAsyncThunk('course/create', async (data, { rejectWithValue }) => {
  try {
    const response = await courseService.createCourse(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const editCourse = createAsyncThunk('course/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await courseService.editCourse(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const deleteCourse = createAsyncThunk('course/delete', async (data, { rejectWithValue }) => {
  try {
    const response = await courseService.deleteOne(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const addCourseContent = createAsyncThunk(
  'courscontent/add',
  async (data, { rejectWithValue }) => {
    try {
      const response = await courseService.addCourseContent(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: [],
  // Separate from `data` (used by getAllCoursesByClass/getAllCoursesByClassSubj,
  // which still return a flat array) since getAllCourses now returns a
  // paginator object -- sharing one key risked CreateQuiz.js's
  // `courses.data.map(...)` blowing up on the paginator's shape.
  adminList: { data: [], current_page: 1, per_page: 10, total: 0, last_page: 1 },
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: "courses",
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked;
    },
    resetSingleData: (state) => {
      state.singleData = {};
    },
  },
  extraReducers: {
    [getAllCourses.pending]: (state) => {
      if (!state.adminList?.data?.length) {
        state.loading = true;
      }
    },
    [getAllCourses.fulfilled]: (state, action) => {
      state.error = false;
      state.adminList = action.payload;
      state.loading = false;
    },
    [getAllCourses.rejected]: (state, action) => {
      state.error = true;
      state.message = action.payload;
      state.loading = false;
    },

    [getAllCoursesByClass.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true;
      }
    },
    [getAllCoursesByClass.fulfilled]: (state, action) => {
      state.error = false;
      state.data = action.payload;
      state.loading = false;
    },
    [getAllCoursesByClass.rejected]: (state, action) => {
      state.error = true;
      state.message = action.payload;
      state.loading = false;
    },

    [getAllCoursesByClassSubj.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true;
      }
    },
    [getAllCoursesByClassSubj.fulfilled]: (state, action) => {
      state.error = false;
      state.data = action.payload;
      state.loading = false;
    },
    [getAllCoursesByClassSubj.rejected]: (state, action) => {
      state.error = true;
      state.message = action.payload;
      state.loading = false;
    },

    [getOneCourse.pending]: (state) => {
      state.loading = true;
    },
    [getOneCourse.fulfilled]: (state, { payload }) => {
      state.message = payload?.message;
      state.loading = false;
      state.singleData = payload;
    },
    [getOneCourse.rejected]: (state, { payload }) => {
      state.error = true;
      state.message = payload;
      state.loading = false;
    },

    [createCourse.pending]: (state) => {
      state.loading = true;
    },
    [createCourse.fulfilled]: (state, { payload }) => {
      state.message = payload?.message;
      state.loading = false;
    },
    [createCourse.rejected]: (state, { payload }) => {
      state.error = true;
      state.message = payload;
      state.loading = false;
    },

    [editCourse.pending]: (state) => {
      state.loading = true;
    },
    [editCourse.fulfilled]: (state, { payload }) => {
      state.message = payload?.message;
      state.loading = false;
    },
    [editCourse.rejected]: (state, { payload }) => {
      state.error = true;
      state.message = payload;
      state.loading = false;
    },

    [deleteCourse.pending]: (state) => {
      state.loading = true;
    },
    [deleteCourse.fulfilled]: (state, { payload }) => {
      state.message = payload?.message;
      state.loading = false;
    },
    [deleteCourse.rejected]: (state, { payload }) => {
      state.error = true;
      state.message = payload;
      state.loading = false;
    },

    [addCourseContent.pending]: (state) => {
      state.loading = true;
    },
    [addCourseContent.fulfilled]: (state, { payload }) => {
      state.message = payload?.message;
      state.loading = false;
    },
    [addCourseContent.rejected]: (state, { payload }) => {
      state.error = true;
      state.message = payload;
      state.loading = false;
    },
  },
});

export const { resetSingleData } = slice.actions
export default slice.reducer
